{
  "verse": {
    "loading": "Chargement du verset...",
    "error": "Impossible de charger le verset",
    "reference": "— Sourate {{surah}}, Verset {{ayah}}",
    "arabicUnavailable": "(Arabe non disponible)",
    "english": "Anglais",
    "arabic": "العربية",
    "swapLanguage_aria": "Changer de langue",
    "toggleLanguage_title": "Basculer Anglais / Arabe",
    "reflect": "Réfléchir",
    "reflecting": "Réflexion…",
    "reflect_aria": "Générer une réflexion personnelle reliant ce verset à votre intention",
    "insights": "Éclairages",
    "insights_aria": "Ouvrir les éclairages coraniques par IA",
    "share": "Partager",
    "share_aria": "Partager ce verset sous forme d'image",
    "share_title": "Partager ce verset",
    "removeFromFavorites_aria": "Retirer des favoris",
    "saveToFavorites_aria": "Ajouter aux favoris",
    "favoritesProLocked_aria": "Les favoris sont une fonctionnalité Pro",
    "favoritesUpgrade_aria": "Passez à Pro pour enregistrer des favoris",
    "signInToSave": "Connectez-vous pour enregistrer des favoris.",
    "failedToUpdateFavorites": "Échec de la mise à jour des favoris",
    "couldNotReflect": "Impossible de générer une réflexion",
    "shareCaption": "« {{text}} »\n— Sourate {{surah}}, Verset {{ayah}}\n\nrhemn.com",
    "imageSavedVerseCopied": "Image enregistrée · verset copié",
    "imageSaved": "Image du verset enregistrée",
    "couldNotCreateImage": "Impossible de créer l'image"
  },
  "insights": {
    "panel_aria": "Panneau des éclairages coraniques",
    "title": "Éclairages",
    "reference": "Sourate {{surah}}, Verset {{ayah}}",
    "close_aria": "Fermer le panneau des éclairages",
    "versePreview_aria": "Aperçu du verset",
    "back_aria": "Retour",
    "tryAgain": "Réessayer",
    "backTo_aria": "Retour à {{ref}}",
    "copyVerse_aria": "Copier {{ref}}",
    "openingVerse": "Ouverture du verset…",
    "verseError": "Impossible d'ouvrir le verset."
  },
  "proGate": {
    "title": "Les éclairages coraniques par IA sont une fonctionnalité Pro",
    "subtitleSafari": "Débloquez une compréhension profonde et contextuelle de chaque verset avec Rhemn Pro. Déjà membre ? Tout se débloque automatiquement à la connexion.",
    "subtitle": "Accédez à une compréhension profonde et contextuelle de chaque verset.",
    "bulletAsk": "Posez n'importe quelle question sur le verset",
    "bulletTafsir": "Résumés de Tafsir instantanés par IA",
    "bulletRelated": "Découvrez des versets thématiquement liés",
    "upgrade": "Passer à Pro"
  },
  "ask": {
    "heading": "Demander",
    "suggestion1": "Quel est le contexte plus large de ce verset ?",
    "suggestion2": "Comment l'appliquer au quotidien ?",
    "suggestion3": "Que disent les savants classiques à ce sujet ?",
    "placeholder": "Posez n'importe quelle question sur ce verset…",
    "input_aria": "Poser une question sur ce verset",
    "submit_aria": "Envoyer la question",
    "submit_title": "Envoyer (⌘↵)",
    "submit_label": "Demander",
    "submit_hint": "⌘↵",
    "suggestions_aria": "Questions suggérées",
    "error": "Impossible d'obtenir une réponse.",
    "pending": "Réflexion sur votre question…",
    "attribution": "Réponse générée par IA · Ne remplace pas un savoir qualifié"
  },
  "tafsir": {
    "heading": "Tafsir",
    "emptyText": "Obtenez un résumé de Tafsir généré par IA pour ce verset.",
    "generate": "Générer le Tafsir",
    "commentary": "Commentaire",
    "regenerate": "Régénérer",
    "regenerate_aria": "Régénérer le Tafsir",
    "attribution": "Résumé généré par IA · Ne remplace pas un savoir qualifié",
    "error": "Impossible de générer le tafsir.",
    "pending": "Lecture du commentaire…"
  },
  "related": {
    "heading": "Versets liés",
    "copied": "Copié : {{ref}}",
    "failedToCopy": "Échec de la copie",
    "empty": "Aucun verset lié trouvé.",
    "error": "Impossible de charger les versets liés.",
    "pending": "Recherche de versets liés…"
  },
  "favorites": {
    "panel_aria": "Versets favoris",
    "title": "Versets favoris",
    "proLocked": "Les versets favoris sont une fonctionnalité Pro.",
    "loading": "Chargement…",
    "failedToLoad": "Échec du chargement des favoris",
    "empty": "Aucun favori pour l'instant. Touchez le cœur sur un verset pour l'enregistrer.",
    "reference": "— Sourate {{surah}}, Verset {{ayah}}",
    "remove_aria": "Retirer des favoris",
    "failedToRemove": "Échec du retrait"
  }
}
